import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { SkeletonLoaderShade } from '../../models/skeleton-loader.enum';

@Component({
  selector: 'f-skeleton-small-card-with-text-and-badges',
  template: `
    <div class="container-fluid heading-50 p-0">
      <div class="row mb-1">
        <f-skeleton class="col-8" [shade]="shade"></f-skeleton>
        <f-skeleton class="col-3 offset-1" [shade]="shade"></f-skeleton>
      </div>
      <div class="row mb-1">
        <f-skeleton class="col-7" [shade]="shade"></f-skeleton>
        <f-skeleton class="col-2 offset-3" [shade]="shade"></f-skeleton>
      </div>
      <div *ngIf="!shortTemplate" class="row mb-1">
        <f-skeleton class="col-7" [shade]="shade"></f-skeleton>
        <f-skeleton class="col-2 offset-3" [shade]="shade"></f-skeleton>
      </div>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FireflySkeletonSmallCardWithTextAndBadgesComponent {
  @Input() shade: SkeletonLoaderShade = SkeletonLoaderShade.Light;
  @Input() shortTemplate = false;
}
